import L from 'L'
L.Icon.Default.imagePath = '/static/images/leaflet/images'

var LeafIcon = L.Icon.extend({
  options: {
    iconSize: [64, 64]
  }
})

module.exports = {
  otherIcon: new LeafIcon({
    iconUrl: '/static/images/singing.png'
  }),
  paintIcon: new LeafIcon({
    iconUrl: '/static/images/painting.png'
  }),
  myIcon: new L.Icon.Default()
}



// WEBPACK FOOTER //
// ./src/assets/js/icon.js